import templateUrl from 'emun.blog/blog-notify.htm'
import BlogPrompt from 'emun.blog/blog-prompt'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import $session from 'servicestack/session'
import resolve from 'ioc/resolve'

class BlogNotifyController {
    constructor($scope) {
        const $ctrl = this;
        basicController($ctrl);
        let $rootScope = resolve('$rootScope');
        $rootScope.$on('activitySaved', () => $ctrl.query.load(true));
        $rootScope.$on('activityDeleted', () => $ctrl.query.load(true));
    }
    $onInit(){
        const $ctrl = this;

		$ctrl.query = new AutoQuery({
            url: 'QueryBlogs.json',
            hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
			criteria: {
				onlyNew: true
			},
			orderBy: '-CreatedOn,Id',
            sortOptions:{
				'CreatedOn,Id': 'Created: Newest',
				'-CreatedOn,Id': 'Created: Oldest'
            },
            autoLoad: true,
            pageSize: 12
        });
    }
    load(){
        const $ctrl = this;
        $ctrl.query.load(true);
    }
}

export default BlogNotifyController;